// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"245":"be5310d5b05f70bc1d81","385":"90947596c59f87de99ce"}[chunkId] + ".js";
};